"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _FormEdit = _interopRequireDefault(require("./FormEdit.vue"));
var activityListApi = _interopRequireWildcard(require("@/api/activityListApi"));
var actievApi = activityListApi;
var _store = require("@/api/store");
var _selectProducts = _interopRequireDefault(require("../../../business/supplier/coupons/selectProducts.vue"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 导入分类API
// 导入选择商品组件
var _default = exports.default = {
  components: {
    FormEdit: _FormEdit.default,
    SelectProducts: _selectProducts.default
  },
  data: function data() {
    return {
      ruleForm: {
        insertOrder: 0,
        // 默认不插入订单
        orderType: 1,
        // 默认普通订单
        allProducts: 0,
        // 默认所有商品
        specifiedProducts: '',
        // 指定的SKU ID列表
        specifiedCategories: [] // 指定的分类ID列表（JSON字符串）
      },
      loading: false,
      details: {},
      mealImg: '',
      formConfig: {
        redirectType: 1,
        redirectUrl: ''
      },
      categoryOptions: [],
      // 分类选项
      selectedCategories: [],
      // 已选分类
      selectedProductsList: [],
      // 已选择的SKU列表
      _cachedProductsList: [],
      // 缓存SKU选择
      _cachedSpecifiedProducts: '',
      // 缓存SKU ID字符串
      _cachedCategories: [],
      // 缓存分类选择
      _cachedSpecifiedCategories: [] // 缓存分类ID字符串
    };
  },
  mounted: function mounted() {
    var id = this.$route.params.id;
    if (id && id != 0) {
      this.getSpecDetail(id);
    } else {
      this.ruleForm = {
        insertOrder: 0,
        orderType: 1,
        allProducts: 0,
        specifiedProducts: '',
        specifiedCategories: []
      };
    }

    // 获取分类列表
    this.getCategoryList();

    // 测试分类数据解析（开发调试用）
    if (process.env.NODE_ENV === 'development') {
      console.log('分类数据解析测试:');
      // 测试用户提供的JSON格式
      var testSpecifiedCategories = "[[3,7],[3,8]]";
      try {
        var parsed = JSON.parse(testSpecifiedCategories);
        console.log('解析结果:', parsed);
        console.log('是否为嵌套数组:', Array.isArray(parsed) && Array.isArray(parsed[0]));
      } catch (e) {
        console.error('解析失败:', e);
      }
    }
  },
  methods: {
    // 获取商品分类
    getCategoryList: function getCategoryList() {
      var _this = this;
      return (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this.categoryOptions = res || [];
        return res;
      }).catch(function (err) {
        _this.$message.error('获取分类列表失败');
        throw err;
      });
    },
    // 处理商品类型变更
    handleProductTypeChange: function handleProductTypeChange(val) {
      // 保存当前的选择，以便切换回来时恢复
      if (this.ruleForm.allProducts === 1) {
        // 保存当前的SKU选择
        this._cachedProductsList = _toConsumableArray(this.selectedProductsList);
        this._cachedSpecifiedProducts = this.ruleForm.specifiedProducts;
      } else if (this.ruleForm.allProducts === 2) {
        // 保存当前的分类选择
        this._cachedCategories = _toConsumableArray(this.selectedCategories);
        this._cachedSpecifiedCategories = _toConsumableArray(this.ruleForm.specifiedCategories);
      }

      // 切换到新的选择类型
      if (val === 0) {
        // 所有商品 - 不需要特别处理
      } else if (val === 1) {
        // 指定SKU - 恢复之前保存的SKU数据
        if (this._cachedProductsList && this._cachedProductsList.length > 0) {
          this.selectedProductsList = _toConsumableArray(this._cachedProductsList);
          this.ruleForm.specifiedProducts = this._cachedSpecifiedProducts || '';
        }
      } else if (val === 2) {
        // 指定分类 - 恢复之前保存的分类数据
        if (this._cachedCategories && this._cachedCategories.length > 0) {
          this.selectedCategories = _toConsumableArray(this._cachedCategories);
          this.ruleForm.specifiedCategories = _toConsumableArray(this._cachedSpecifiedCategories) || [];
        }
      }
    },
    // 处理分类选择变更
    handleCategoryChange: function handleCategoryChange(val) {
      // el-cascader多选模式下，val是二维数组：[[1,2,3], [4,5,6]]
      // 我们需要将这个格式保存到ruleForm.specifiedCategories
      if (val && val.length > 0) {
        // 直接保存路径数组，提交时会转换为后端需要的格式
        this.ruleForm.specifiedCategories = val;
        console.log('选择的分类路径数组:', val);
      } else {
        this.ruleForm.specifiedCategories = [];
      }
    },
    // 将分类ID数组转换为路径数组（用于el-cascader多选显示）
    convertCategoryIdsToPaths: function convertCategoryIdsToPaths(categoryIds) {
      var _this2 = this;
      return new Promise(function (resolve) {
        if (!categoryIds || categoryIds.length === 0) {
          resolve([]);
          return;
        }

        // 递归查找分类路径
        var findCategoryPaths = function findCategoryPaths(categories, targetIds) {
          var paths = [];
          var _findPath = function findPath(nodes, targetId) {
            var currentPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
            var _iterator = _createForOfIteratorHelper(nodes),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var node = _step.value;
                var newPath = [].concat(_toConsumableArray(currentPath), [node.id]);
                if (node.id === targetId) {
                  return newPath;
                }
                if (node.child && node.child.length > 0) {
                  var found = _findPath(node.child, targetId, newPath);
                  if (found) {
                    return found;
                  }
                }
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            return null;
          };
          targetIds.forEach(function (id) {
            var path = _findPath(categories, id);
            if (path) {
              paths.push(path);
            }
          });
          return paths;
        };

        // 使用已加载的分类数据
        if (_this2.categoryOptions && _this2.categoryOptions.length > 0) {
          var paths = findCategoryPaths(_this2.categoryOptions, categoryIds);
          resolve(paths);
        } else {
          // 如果分类数据还没加载，先加载再转换
          _this2.getCategoryList().then(function () {
            var paths = findCategoryPaths(_this2.categoryOptions, categoryIds);
            resolve(paths);
          }).catch(function () {
            resolve([]);
          });
        }
      });
    },
    // 打开选择商品弹窗
    openSelectProducts: function openSelectProducts() {
      var _this3 = this;
      // 确保已选商品数据被正确传递到选择组件
      this.$nextTick(function () {
        if (_this3.$refs.SelectProductsRef) {
          // 先确保组件内部的值与当前已选商品同步
          _this3.$refs.SelectProductsRef.$emit('input', _this3.selectedProductsList);
          // 然后打开弹窗
          _this3.$refs.SelectProductsRef.openInit();
        }
      });
    },
    // 选择商品后的回调
    handleSelectedProducts: function handleSelectedProducts(products) {
      if (products && products.length > 0) {
        // 获取已选择的商品完整信息
        this.selectedProductsList = products.map(function (item) {
          return {
            id: item.id,
            skuCode: item.skuCode || '',
            skuName: item.skuName || item.storeName || '',
            image: item.image || '',
            otPrice: item.otPrice || item.price || '0'
          };
        });

        // 更新SKU ID字符串（逗号分隔）
        this.ruleForm.specifiedProducts = this.selectedProductsList.map(function (item) {
          return item.id;
        }).join(',');
        this.$message.success("\u5DF2\u9009\u62E9".concat(this.selectedProductsList.length, "\u4E2A\u5546\u54C1"));
      } else {
        this.selectedProductsList = [];
        this.ruleForm.specifiedProducts = '';
      }
    },
    // 移除已选择的商品
    handleRemoveProduct: function handleRemoveProduct(index, row) {
      this.selectedProductsList.splice(index, 1);
      this.ruleForm.specifiedProducts = this.selectedProductsList.map(function (item) {
        return item.id;
      }).join(',');
    },
    // 提交保存
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this4 = this;
      this.$refs[form].validate(function (valid) {
        var _this4$$refs$FormEdit;
        var lists = (_this4$$refs$FormEdit = _this4.$refs['FormEditRef']) === null || _this4$$refs$FormEdit === void 0 ? void 0 : _this4$$refs$FormEdit.getMealVal();
        var formLists = JSON.parse(JSON.stringify(lists || []));
        if (!valid) return;
        setTimeout(function () {
          var _formLists, _formLists2, _this4$$refs$FormEdit2;
          var _ref = _this4.ruleForm || {},
            id = _ref.id,
            remark = _ref.remark,
            status = _ref.status,
            title = _ref.title,
            _ref$totalLimit = _ref.totalLimit,
            totalLimit = _ref$totalLimit === void 0 ? 0 : _ref$totalLimit,
            _ref$userLimit = _ref.userLimit,
            userLimit = _ref$userLimit === void 0 ? 0 : _ref$userLimit,
            _ref$insertOrder = _ref.insertOrder,
            insertOrder = _ref$insertOrder === void 0 ? 0 : _ref$insertOrder,
            _ref$orderType = _ref.orderType,
            orderType = _ref$orderType === void 0 ? 1 : _ref$orderType,
            _ref$allProducts = _ref.allProducts,
            allProducts = _ref$allProducts === void 0 ? 0 : _ref$allProducts,
            _ref$specifiedProduct = _ref.specifiedProducts,
            specifiedProducts = _ref$specifiedProduct === void 0 ? '' : _ref$specifiedProduct,
            _ref$specifiedCategor = _ref.specifiedCategories,
            specifiedCategories = _ref$specifiedCategor === void 0 ? [] : _ref$specifiedCategor;
          formLists = (_formLists = formLists) === null || _formLists === void 0 ? void 0 : _formLists.map(function (item) {
            var _ref2 = item || {},
              type = _ref2.type,
              formTitle = _ref2.formTitle;
            return _objectSpread(_objectSpread({}, item), {}, {
              formTitle: type == 'tips' ? '说明文字' : formTitle
            });
          });
          var submitForm = ((_formLists2 = formLists) === null || _formLists2 === void 0 ? void 0 : _formLists2.filter(function (item) {
            var _ref3 = item || {},
              type = _ref3.type,
              formTitle = _ref3.formTitle,
              options = _ref3.options;
            var selectOption = options === null || options === void 0 ? void 0 : options.filter(function (v) {
              return v.name;
            });
            return type && formTitle && (['select', 'radio', 'checkbox'].includes(type) ? selectOption === null || selectOption === void 0 ? void 0 : selectOption.length : true);
          })) || [];
          if (!submitForm.length) {
            _this4.$message.warning('请至少填写一项完整表单内容！');
            return;
          }
          ;

          // 获取表单提交后的跳转配置
          var formConfig = ((_this4$$refs$FormEdit2 = _this4.$refs['FormEditRef']) === null || _this4$$refs$FormEdit2 === void 0 ? void 0 : _this4$$refs$FormEdit2.getFormConfig()) || {};

          // 处理分类数据格式转换
          var submitSpecifiedCategories = [];
          if (allProducts === 2) {
            // 如果是指定分类，需要转换数据格式
            if (Array.isArray(specifiedCategories) && specifiedCategories.length > 0) {
              // 检查是否是el-cascader多选的格式：[[1,2,3], [4,5,6]]
              if (Array.isArray(specifiedCategories[0])) {
                // 这是路径数组格式，直接使用（后端需要的就是这种嵌套数组格式）
                submitSpecifiedCategories = specifiedCategories;
              } else {
                // 这是简单的ID数组格式，需要转换为路径数组
                // 但由于后端可能也支持简单ID数组，这里先尝试直接使用
                submitSpecifiedCategories = specifiedCategories;
              }
            } else if (typeof specifiedCategories === 'string' && specifiedCategories) {
              // 字符串格式，尝试解析
              try {
                submitSpecifiedCategories = JSON.parse(specifiedCategories);
              } catch (e) {
                submitSpecifiedCategories = specifiedCategories.split(',').map(function (id) {
                  return parseInt(id.trim());
                }).filter(Boolean);
              }
            }
          }
          console.log('提交分类数据:', submitSpecifiedCategories);
          _this4.loading = true;
          activityListApi.saveSkinForm({
            content: JSON.stringify(submitForm),
            id: id,
            remark: remark,
            status: status,
            title: title,
            totalLimit: totalLimit,
            userLimit: userLimit,
            redirectType: formConfig.redirectType || 1,
            redirectUrl: formConfig.redirectType === 2 ? formConfig.redirectUrl : '',
            // 现在redirectUrl存储的是链接ID
            insertOrder: insertOrder,
            // 是否插入订单
            orderType: orderType,
            // 订单类型
            allProducts: allProducts,
            // 指定商品类型：0-所有商品，1-指定SKU，2-指定分类
            specifiedProducts: allProducts === 1 ? specifiedProducts : '',
            // 指定的SKU
            specifiedCategories: submitSpecifiedCategories // 指定的分类 - 数组形式
          }).then(function (data) {
            _this4.$closeCompletedView();
            _this4.$message.success('操作成功');
            _this4.loading = false;
            _this4.goReturn();
          }).catch(function () {
            _this4.loading = false;
          });
        }, 100);
      });
    }),
    // 获取详情
    getSpecDetail: function getSpecDetail(id) {
      var _this5 = this;
      this.ruleForm = {};
      activityListApi.detailSkinForm({
        id: id
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res,
          content,
          selectedCategories,
          parsedCategories,
          categoryIds,
          selectedProductsList,
          productIds,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              res = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              content = (res === null || res === void 0 ? void 0 : res.content) && JSON.parse(res.content); // 处理分类选择数据，如果有分类数据则转换为数组
              selectedCategories = [];
              if (!(res.specifiedCategories && res.allProducts === 2)) {
                _context.n = 7;
                break;
              }
              _context.p = 1;
              // 尝试解析为JSON数组
              parsedCategories = JSON.parse(res.specifiedCategories); // 如果是嵌套数组（分类路径数组），直接使用
              if (!(Array.isArray(parsedCategories) && parsedCategories.length > 0 && Array.isArray(parsedCategories[0]))) {
                _context.n = 2;
                break;
              }
              // 这是el-cascader多选需要的格式：[[1,2,3], [4,5,6]]
              selectedCategories = parsedCategories;
              console.log('解析后的分类路径数组:', selectedCategories);
              _context.n = 4;
              break;
            case 2:
              if (!Array.isArray(parsedCategories)) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return _this5.convertCategoryIdsToPaths(parsedCategories);
            case 3:
              selectedCategories = _context.v;
              console.log('转换后的分类路径数组:', selectedCategories);
            case 4:
              _context.n = 7;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              console.error('解析JSON分类数据失败，尝试逗号分隔方式', _t);
              // 尝试逗号分隔方式解析
              categoryIds = res.specifiedCategories.split(',').filter(function (id) {
                return id.trim();
              }).map(function (id) {
                return parseInt(id);
              });
              if (!(categoryIds.length > 0)) {
                _context.n = 7;
                break;
              }
              _context.n = 6;
              return _this5.convertCategoryIdsToPaths(categoryIds);
            case 6:
              selectedCategories = _context.v;
            case 7:
              // 处理已选择的SKU数据
              selectedProductsList = [];
              if (res.allProducts === 1) {
                // 优先使用后端返回的完整商品信息
                if (res.skuList && Array.isArray(res.skuList) && res.skuList.length > 0) {
                  // 使用后端返回的完整商品信息
                  selectedProductsList = res.skuList.map(function (item) {
                    return {
                      id: item.id,
                      skuCode: item.skuCode || '',
                      skuName: item.storeName || '',
                      image: item.image || '',
                      otPrice: item.price || '0'
                    };
                  });
                  console.log('使用后端返回的商品信息:', selectedProductsList);
                } else if (res.specifiedProducts) {
                  // 后端没有返回完整商品信息，使用ID列表
                  productIds = res.specifiedProducts.split(',').filter(function (id) {
                    return id.trim();
                  });
                  if (productIds.length > 0) {
                    selectedProductsList = productIds.map(function (id) {
                      return {
                        id: id,
                        skuCode: '',
                        skuName: "SKU-".concat(id),
                        image: '',
                        otPrice: '0'
                      };
                    });
                    // 尝试加载详细SKU数据
                    _this5.loadProductDetails(productIds);
                  }
                }
              }
              _this5.ruleForm = _objectSpread(_objectSpread({}, res), {}, {
                formLists: content === null || content === void 0 ? void 0 : content.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    itemKey: (item === null || item === void 0 ? void 0 : item.itemKey) || actievApi.generateRandomString(10)
                  });
                }),
                // 确保有默认值
                insertOrder: res.insertOrder || 0,
                orderType: res.orderType || 1,
                allProducts: res.allProducts || 0,
                specifiedProducts: res.specifiedProducts || '',
                // 确保分类数据是数组形式
                specifiedCategories: selectedCategories
              });

              // 设置已选分类和商品
              _this5.selectedCategories = selectedCategories;
              _this5.selectedProductsList = selectedProductsList;

              // 同时缓存这些数据，以便切换类型后能恢复
              _this5._cachedCategories = _toConsumableArray(selectedCategories);
              _this5._cachedSpecifiedCategories = _toConsumableArray(selectedCategories);
              _this5._cachedProductsList = _toConsumableArray(selectedProductsList);
              _this5._cachedSpecifiedProducts = res.specifiedProducts || '';

              // 设置表单配置信息
              if (res.redirectType) {
                _this5.formConfig = {
                  redirectType: res.redirectType,
                  redirectUrl: res.redirectUrl || ''
                };
              }
            case 8:
              return _context.a(2);
          }
        }, _callee, null, [[1, 5]]);
      })));
    },
    // 加载商品详细信息
    loadProductDetails: function loadProductDetails(productIds) {
      // 可以通过API加载详细的商品信息
      // 这里可以根据你的系统实现，加载商品详情后更新selectedProductsList
      // 例如：
      /*
      productAPI.getProductsByIds(productIds).then(products => {
      	this.selectedProductsList = products.map(p => ({
      		id: p.id,
      		skuCode: p.skuCode,
      		skuName: p.skuName,
      		image: p.image,
      		otPrice: p.otPrice
      	}));
      }).catch(err => {
      	console.error('加载商品详情失败', err);
      });
      */
    },
    // 返回列表
    goReturn: function goReturn() {
      this.$router.push('/applet/skinForm');
    }
  }
};